import React from "react";

import ThemeButton from "./ThemeButton";
import VolumeSlider from "./VolumeSlider";
import "./menu.css";
import { useProgress } from "@react-three/drei";
import { useRef } from "react";
import { useEffect } from "react";
import gsap from "gsap";
import LangButton from "./LangButton";

export default function Menu() {
  const { progress } = useProgress();
  const ref = useRef();

  //Show menu when loading is complete
  useEffect(() => {
    const animate = async () => {
      if (progress === 100)
        await gsap.to(ref.current, {
          scale: 1,
          duration: 0.5,
          ease: "ease.out",
        });
    };
    animate();
  }, [progress]);

  return (
    <div className="menu" ref={ref}>
      <ThemeButton />
      <LangButton />
      <VolumeSlider />
    </div>
  );
}
